var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFeedback = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.01 23.67C11.53 23.67 11.05 23.5 10.67 23.16L6.92 20H0V3C0 1.35 1.35 0 3 0H21C22.65 0 24 1.35 24 3V20H17.15L13.3 23.18C12.94 23.5 12.47 23.67 12.01 23.67ZM2 18H7.65L11.98 21.64L16.43 18H22V3C22 2.45 21.55 2 21 2H3C2.45 2 2 2.45 2 3V18ZM17.67 12.75L16.34 11.26C16.34 11.26 14.34 13.01 12 13.01C9.66 13.01 7.68 11.28 7.67 11.26L6.34 12.75C6.44 12.84 8.9 15 12.01 15C15.12 15 17.57 12.84 17.68 12.75H17.67ZM8.5 6C7.67 6 7 6.67 7 7.5C7 8.33 7.67 9 8.5 9C9.33 9 10 8.33 10 7.5C10 6.67 9.33 6 8.5 6ZM15.5 6C14.67 6 14 6.67 14 7.5C14 8.33 14.67 9 15.5 9C16.33 9 17 8.33 17 7.5C17 6.67 16.33 6 15.5 6Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFeedback, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/feedback.6ee7c5b0.svg";
export { ForwardRef as ReactComponent };